import http from './api'

const route = 'app/comercial/analiseprodutos/'

export default {
  showAnaliseFaturamento: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showAnaliseFaturamento', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showAnaliseProdutoDevolucao: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showAnaliseProdutoDevolucao', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showAnaliseProdutosKgFaturados: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showAnaliseProdutosKgFaturados', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showAnaliseProdutoFatClassificacao: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showAnaliseProdutoFatClassificacao', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showGraficoFaturamentoKgGrupo: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showGraficoFaturamentoKgGrupo', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showGraficoFaturamentoPrecoMedioGrupo: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showGraficoFaturamentoPrecoMedioGrupo', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showAnaliseFaturamentoGrupoProdutos: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showAnaliseFaturamentoGrupoProdutos', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showFaturamentoGrupoMes: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showFaturamentoGrupoMes', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showAnaliseCompartivoFaturamentoMes: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento) => {
    return http.post(route + 'showAnaliseCompartivoFaturamentoMes', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
    })
  },

  showAnaliseProdutoDevolucaoLinha: (dataInicial, dataFinal, select, vendedor, area, rede, supervisor, tokencontrato, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showAnaliseProdutoDevolucaoLinha', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedor: vendedor,
      area: area,
      rede: rede,
      supervisor: supervisor,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },
}
